const comMain = () => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    let sec = document.querySelector('#jsComSecMain');
    let wrap = sec.querySelector('.js-main-wrap');

    let imgBox = wrap.querySelector('.js-img-box');
    // let coverBox = wrap.querySelector('.js-cover-box');
    let ttlBox = wrap.querySelector('.js-ttl-box');
    // let copyBox = wrap.querySelector('.js-copy-box');


    setTimeout(() => {
      imgBox.classList.add('is-act')
      
      setTimeout(() => {
        // coverBox.classList.add('is-act')
        ttlBox.classList.add('is-act')
      }, 1200);

    }, 200);



  }
}
export default comMain;